import { Route, RoutePath } from '@core/types/route';

import { BENJAMIN_KEGLER_CV } from '../assets/data/benjamin-kegler-cv';
import { DANIEL_DONACZI_CV } from '../assets/data/daniel-donaczi-cv';
import { DIMITRI_ERMISCH_CV } from '../assets/data/dimitri-ermisch-cv';
import { ELENA_ZANDER_CV } from '../assets/data/elena-zander-cv';
import { EMMANUEL_BRUN_CV } from '../assets/data/emmanuel-brun-cv';
import { MARTIN_LANDOLT_CV } from '../assets/data/martin-landolt-cv';
import { MICHAEL_PROCKL_CV } from '../assets/data/michael-prockl-cv';
import { WALDEMAR_LOTZ_CV } from '../assets/data/waldemar-lotz-cv';
import InstructorTemplate from '../components/InstructorTemplate';
import Home from '../pages/Home';
import AlexanderSolovev from '../pages/instructors/AlexanderSolovev';
import FalkoZander from '../pages/instructors/FalkoZander';
import Kontakt from '../pages/Kontakt';
import Agb from '../pages/legal/Agb';
import Datenschutz from '../pages/legal/Datenschutz';
import Impressum from '../pages/legal/Impressum';
import InstructorProgram from '../pages/martial-arts-instructor-program/InstructorProgram';
import KnowledgeBase from '../pages/martial-arts-knowledge-base/KnowledgeBase';
import Ranking from '../pages/martial-arts-ranking/Ranking';
import SelfDefense from '../pages/martial-arts-self-defense/SelfDefense';
import JuJutsu from '../pages/martial-arts/JuJutsu';
import MartialArtsFaq from '../pages/martial-arts/MartialArtsFaq';
import SolovevStyle from '../pages/martial-arts/SolovevStyle';
import SystemaRyabko from '../pages/martial-arts/SystemaRyabko';
import Sitemap from '../pages/Sitemap';

export const LEGAL_ROUTES: Route[] = [
  { element: <Agb />, name: 'agb', path: RoutePath.Agb, text: 'Agb' },
  {
    element: <Datenschutz />,
    name: 'datenschutz',
    path: RoutePath.Datenschutz,
    text: 'Datenschutz',
  },
  { element: <Impressum />, name: 'impressum', path: RoutePath.Impressum, text: 'Impressum' },
];

export const CORE_ROUTES: Route[] = [
  { element: <Home />, name: 'home', path: RoutePath.Home, text: 'Startseite' },
  { element: <Kontakt />, name: 'contact', path: RoutePath.Kontakt, text: 'Kontakt' },
  { element: <Sitemap />, name: 'sitemap', path: RoutePath.Sitemap, text: 'Sitemap' },
];

export const INSTRUCTOR_ROUTES: Route[] = [
  {
    element: <AlexanderSolovev />,
    name: 'alexander',
    path: RoutePath.AlexanderSolovev,
    text: 'Alexander Solovev',
  },
  { element: <FalkoZander />, name: 'falko', path: RoutePath.FalkoZander, text: 'Falko Zander' },
  {
    element: <InstructorTemplate {...ELENA_ZANDER_CV} />,
    name: 'elena',
    path: RoutePath.ElenaZander,
    text: 'Elena Zander',
  },
  {
    element: <InstructorTemplate {...DANIEL_DONACZI_CV} />,
    name: 'daniel',
    path: RoutePath.DanielDonaczi,
    text: 'Daniel Donaczi',
  },
  {
    element: <InstructorTemplate {...BENJAMIN_KEGLER_CV} />,
    name: 'benjamin',
    path: RoutePath.BenjaminKegler,
    text: 'Benjamin Kegler',
  },
  {
    element: <InstructorTemplate {...MICHAEL_PROCKL_CV} />,
    name: 'michael',
    path: RoutePath.MichaelProckl,
    text: 'Michael Prockl',
  },
  {
    element: <InstructorTemplate {...MARTIN_LANDOLT_CV} />,
    name: 'martin',
    path: RoutePath.MartinLandolt,
    text: 'Martin Landolt',
  },
  {
    element: <InstructorTemplate {...DIMITRI_ERMISCH_CV} />,
    name: 'dimitri',
    path: RoutePath.DimitriErmisch,
    text: 'Dimitri Ermisch',
  },
  {
    element: <InstructorTemplate {...WALDEMAR_LOTZ_CV} />,
    name: 'waldemar',
    path: RoutePath.WaldemarLotz,
    text: 'Waldemar Lotz',
  },
  {
    element: <InstructorTemplate {...EMMANUEL_BRUN_CV} />,
    name: 'emmanuel',
    path: RoutePath.EmmanuelBrun,
    text: 'Emmanuel Brun',
  },
];

export const MARTIAL_ART_ROUTES: Route[] = [
  {
    element: <SolovevStyle />,
    name: 'solovev-style',
    path: RoutePath.SolovevStyle,
    text: 'Solovev Style',
  },
  {
    element: <SystemaRyabko />,
    name: 'systema-ryabko',
    path: RoutePath.SystemaRyabko,
    text: 'Systema Ryabko',
  },
  { element: <JuJutsu />, name: 'ju-jutsu', path: RoutePath.JuJutsu, text: 'Ju-Jutsu' },
  {
    element: <MartialArtsFaq />,
    name: 'ma-faq',
    path: RoutePath.KampfkunstFaq,
    text: 'Kampfkunst FAQ',
  },
  {
    element: <Ranking />,
    name: 'ma-ranking',
    path: RoutePath.KampfkunstRanking,
    text: 'Kampfkunst Methode',
  },
  {
    element: <InstructorProgram />,
    name: 'ma-instructor',
    path: RoutePath.KampfkunstInstructorProgram,
    text: 'Zertifizierung',
  },
  {
    element: <KnowledgeBase />,
    name: 'ma-kb',
    path: RoutePath.Kampfkunst,
    text: 'Kampfkunst Information',
  },
];

export const SELF_DEFENSE: Route[] = [
  {
    element: <SelfDefense />,
    name: 'self-defense',
    path: RoutePath.Selbstverteidigung,
    text: 'Selbstverteidigung',
  },
];
